import { RegisterModule } from '@/typings/common'
/* eslint object-curly-newline: 0 */
import { UsersParticipantsState, UsersParticipantsGetters, UsersParticipantsMutations, UsersParticipantsActions } from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: UsersParticipantsState,
    getters: UsersParticipantsGetters,
    mutations: UsersParticipantsMutations,
    actions: UsersParticipantsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as usersParticipantsStoreModule,
  mapper as usersParticipantsMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
